type Environment = {
  gatewayEndpoint: string
  stripePublishableKey: string
  payPalClientId: string
  googleMapsApiKey: string
  adminAssetsUrl: string
  profanityFilterEnabledCharityIds: string[]
  extraBlockedWordsOrPhrases: string[]
}

if (!process.env.NEXT_PUBLIC_GATEWAY_ENDPOINT) {
  console.warn('Runtime error: NEXT_PUBLIC_GATEWAY_ENDPOINT is not defined')
}

if (!process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_API_KEY) {
  console.warn('Runtime error: NEXT_STRIPE_PUBLISHABLE_API_KEY is not defined')
}

if (!process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID) {
  console.warn('Runtime error: NEXT_PUBLIC_PAYPAL_CLIENT_ID is not defined')
}

if (!process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY) {
  console.warn('Runtime error: NEXT_PUBLIC_GOOGLE_MAPS_API_KEY is not defined')
}

if (!process.env.NEXT_PUBLIC_ADMIN_ASSETS_URL) {
  console.warn('Runtime error: NEXT_PUBLIC_ADMIN_ASSETS_URL is not defined')
}

const environment: Environment = {
  gatewayEndpoint: process.env.NEXT_PUBLIC_GATEWAY_ENDPOINT!,
  stripePublishableKey: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_API_KEY!,
  payPalClientId: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID!,
  googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!,
  adminAssetsUrl: process.env.NEXT_PUBLIC_ADMIN_ASSETS_URL!,
  profanityFilterEnabledCharityIds: process.env.NEXT_PUBLIC_PROFANITY_FILTER_ENABLED_CHARITY_IDS
    ? JSON.parse(process.env.NEXT_PUBLIC_PROFANITY_FILTER_ENABLED_CHARITY_IDS)
    : [],
  extraBlockedWordsOrPhrases: process.env.NEXT_PUBLIC_EXTRA_BLOCKED_WORDS_OR_PHRASES
    ? JSON.parse(process.env.NEXT_PUBLIC_EXTRA_BLOCKED_WORDS_OR_PHRASES)
    : [],
}

export default environment
